import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import {
  Observable,
  Subscription,
  catchError,
  mergeMap,
  of,
  switchMap,
  throwError,
} from "rxjs";
import { Auth, authState, idToken } from "@angular/fire/auth";
import { getLocalStorage } from "../local-storage";
import { LoadingService } from "../loading/loading.service";
import { AlertaService } from "../alerta/alerta.service";

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const alertaServices = inject(AlertaService);
  const auth: Auth = inject(Auth);
  const idToken$ = idToken(auth);

  return idToken$.pipe(
    switchMap((token: any) => {
      if (token) {
        req = req.clone({ setHeaders: { Authorization: `${token}` } });
      }
      return next(req);
    }),
    catchError((error: any) => {
      console.log(error);
      //loadingService.hide();
      //alertaServices.open("Error en la petición", JSON.stringify(error));
      const errorResponse = new HttpResponse({
        body: { error: true, message: error.error || "Unknown error" },
        status: error.status || 500,
        statusText: error.statusText,
        url: error.url,
      });

      return of(errorResponse as HttpEvent<unknown>);
    })
  );
};
